import { render, staticRenderFns } from "./PartnerInfoActivates.vue?vue&type=template&id=a83ba11c&scoped=true"
import script from "./PartnerInfoActivates.vue?vue&type=script&lang=js"
export * from "./PartnerInfoActivates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83ba11c",
  null
  
)

export default component.exports